import { useState } from 'react';
import DireccionesTab from './UnidadesOrgDireccionesTab';

const tabsList = [
  { key: 'direcciones', label: 'Direcciones' },
];

export default function UnidadesOrgTabs({ unitId, onUpdate, puedeCrear, puedeEditar, puedeEliminar }) {
  const [active, setActive] = useState('direcciones');
  const hasValidContext = Number(unitId || 0) > 0;

  if (!hasValidContext) {
    return (
      <div className="person-tabs-disabled">
        <span>
          Selecciona o crea una unidad organizacional y pulsa <b>Editar</b> para gestionar sus datos
          relacionados.
        </span>
      </div>
    );
  }

  return (
    <div className="person-tabs-wrap">
      <div className="person-tabs-bar">
        {tabsList.map((t) => (
          <button
            key={t.key}
            className={`person-tab ${active === t.key ? 'is-active' : ''}`}
            onClick={() => setActive(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="person-tab-panel">
        {active === 'direcciones' && (
          <DireccionesTab
            fkValue={unitId}
            onUpdate={onUpdate}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
      </div>
    </div>
  );
}
